import UniverseParagraphComponent from "./universe-paragraph-component";
import UniverseParagraphConfig from "./universe-paragraph-config";
import UniverseParagraphAdvancedConfig from "./universe-paragraph-advanced-config";

export default {
  UniverseParagraphComponent,
  UniverseParagraphConfig,
  UniverseParagraphAdvancedConfig
};
